const state = {
    currentSearchAgent: null,
    currentWorkspace: null,
    currentPageInfo: null,
    edit: false,
    delete: false
}

export default state
